import dayjs from 'dayjs'

// 将下划线换为驼峰
export const replaceUnderLine = (val, char = '_') => {
  const arr = val.split('')
  const index = arr.indexOf(char)
  arr.splice(index, 2, arr[index + 1].toUpperCase())
  val = arr.join('')
  return val
}

// 替换对象中的下划线属性
export const filterUnderLine = (obj, char = '_') => {
  const arr = Object.keys(obj).filter(item => item.indexOf(char) !== -1)
  arr.forEach(item => {
    const before = obj[item]
    const key = replaceUnderLine(item)
    obj[key] = before
    delete obj[item]
  })
  return obj
}

export const getDateListByDateRange = (dateRange) => {
  let dateList = null
  if (dateRange) {
    if (!dateRange[1]) {
      dateList = dateRange
    } else {
      const date1 = dayjs(dateRange[0])
      const date2 = dayjs(dateRange[1])
      const diffDays = date2.diff(date1, 'day')
      dateList = [dateRange[0]]
      for (let i = 1; i <= diffDays; i++) {
        dateList.push(date1.add(i, 'day').format('YYYY-MM-DD').toString())
      }
    }
  }
  return dateList
}

export const verifyHuaming = (name) => {
  const pattern = /^[\u4E00-\u9FA5]{2}$/
  if (pattern.test(name)) {
    return true
  } else {
    return false
  }
}


// WEBPACK FOOTER //
// ./src/utils/index.js